import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/client";

export default function AdminProducts() {
  const [products, setProducts] = useState([]);
  const [deleting, setDeleting] = useState(null);

  const load = () =>
    api.get("/admin/products").then((r) => setProducts(r.data.products)).catch(() => {});

  useEffect(() => { load(); }, []);

  async function handleDelete(e, p) {
    e.preventDefault();
    e.stopPropagation();
    if (!window.confirm(`Delete "${p.name}"? It will be removed from the store. Existing orders are kept.`)) return;
    setDeleting(p._id);
    try {
      await api.delete(`/admin/products/${p._id}`);
      setProducts((rows) => rows.filter((x) => x._id !== p._id));
    } catch {
      alert("Delete failed. Try again.");
    } finally {
      setDeleting(null);
    }
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <h1 style={{ margin: 0 }}>Products</h1>
        <Link to="/admin/products/new" className="btn primary" style={{ padding: "8px 16px", fontSize: 13 }}>+ Add product</Link>
      </div>
      <div className="list">
        {products.map((p) => (
          <Link key={p._id} to={`/admin/products/${p._id}`} className="row">
            <img src={`/${p.image}`} alt="" style={{ width: 40, height: 40, borderRadius: 10, objectFit: "cover" }}
              onError={(e) => { e.target.style.display = "none"; }} />
            <div className="grow">
              <div className="truncate" style={{ fontWeight: 700 }}>{p.name}</div>
              <div className="muted small">
                {p.api === "yes" ? `${p.apiName} · ${p.region}` : "Manual"} · {p.cost.length} packs · {p.fields} fields
              </div>
            </div>
            {p.disabled && <span className="badge review">Disabled</span>}
            <button
              type="button"
              className="btn danger"
              style={{ padding: "6px 12px", fontSize: 12, marginLeft: 10 }}
              disabled={deleting === p._id}
              onClick={(e) => handleDelete(e, p)}
            >
              {deleting === p._id ? "…" : "Del"}
            </button>
          </Link>
        ))}
      </div>
    </div>
  );
}